export default {
  name: 'Full name',
  customer_name: 'Customer name',
  phone: 'Phone number',
  phone_book: 'eg. Country code - Phone Number',
  address: 'Address',
  email: 'Email',
  email_book: 'Email to receive E-ticket',
  address_book: 'Address',
  load_more: 'See more',
  order_by_label: 'Sort by',
  list_title: 'Find the cheapest bus tickets from {from} to {to} on {date}',
  result_empty_title: 'Trip not found',
  result_empty_content_1: 'We are currently not updating online orders',
  result_empty_content_2: '{route} on {date}',
  result_empty_content_3: 'Please search for a trip with a different departure date or change your search route.',
  note: 'Note',
  something_went_wrong: 'Something went wrong',
  something_went_wrong_content: 'An unexpected error has occurred.</br>' +
      'Please wait a moment and try again.</br>' +
      'If this occurs repeatedly, please call the hotline for support.',
  rebook_tickets: 'Book another ticket',
  ticket_code: 'Ticket code',
  ticket_code_placeholder: 'Input ticket code',
  see_ticket_info: 'See ticket info',
  phone_placeholder: 'Input booking phone number',
  ticket_code_error: 'Please input your ticket code',
  phone_error: 'Please input your phone number',
  ticket_info_title: 'Enter ticket code',
  ticket_info_note: 'In case you can not cancel ticket through website or want to change ticket, please contact us via {phone}.',
  service_fee_name: 'Additional Service Fee',
  surcharge: 'Surcharge',
  vuilongchondulieu: 'Please select data',
}
